export default {
  easyLanguage: 'Łatwy język',
  videoDoesNotYetExist: 'Wideo jeszcze nie istnieje'
}



// WEBPACK FOOTER //
// ./src/i18n/common/pl.js